require("console-polyfill/index");
require("jquery-match-height/dist/jquery.matchHeight-min");

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()